import { all, put, select, takeEvery } from 'redux-saga/effects'

import { Game, Api, Auth } from '../../Core'
import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'

import * as pointsManagerActions from '../PointsManager/pointsManager.actions'
import * as miningActions from '../Mining/mining.actions'
import * as eventsActions from '../Events/events.actions'
import * as quizzesSelector from '../Quizzes/quizzes.selectors'
import * as actions from './quizzes.actions'

import AnswerQuestion from './AnswerQuestion'
import CreateQuestion from './CreateQuestion'
import DisputeQuestionList from './DisputeQuestionList'
import RefuseAlertPopup from './RefuseAlertPopup'
import RefuseQuestion from './RefuseQuestion'
import VoteQuestion from './VoteQuestion'
import WildcardPopup from './WildcardPopup'

const EVENT_PERCENT = 10
const GIVE_LIKE_PRIZE = 3

export function* loadComponents() {
  const components = {
    AnswerQuestion,
    CreateQuestion,
    DisputeQuestionList,
    RefuseAlertPopup,
    RefuseQuestion,
    VoteQuestion,
    WildcardPopup,
  }

  yield put(Game.actions.registerComponents(components))
}

export function* init() {
  yield loadComponents()
}

export function* buyWildcard() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const payload = { groupId: userInfo.licenseData.groupId }
  try {
    yield Api.post(`/buyWildcard`, {}, payload)
    yield put(audioActions.playHowlAudio('cash_register'))
  } catch (e) {
    yield handleError(e, 'buyWildcard', true)
  }
}

export function* getQuestion() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  try {
    const question = yield Api.get(
      `/questions/next?groupId=${userInfo.licenseData.groupId}&playerId=${userInfo.licenseId}`,
      {}
    )
    yield put(actions.setQuestion(question))
    yield put(actions.saveQuestionOk())
  } catch (e) {
    yield handleError(e, 'no_question', false)
  }
}

export function* getUserQuestions(uid, groupId) {
  try {
    const questions = yield Api.get(`/questions/list?groupId=${groupId}&playerId=${uid}`, {})
    return questions
  } catch (e) {
    yield handleError(e, 'no_questions', false)
  }
}
export function* getFederationCorrectAnswers(federationId) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  try {
    const correctAnswers = yield Api.get(
      `/questions/federationCorrectAnswers?groupId=${userInfo.licenseData.groupId}&federationId=${federationId}`,
      {}
    )
    return correctAnswers
  } catch (e) {
    yield handleError(e, 'federations_no_answers', false)
  }
}

export function* getQuestionsList() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const questions = yield getUserQuestions(userInfo.licenseId, userInfo.licenseData.groupId)
  yield put(actions.setQuestionsList(questions))
}

export function* getDisputeQuestion() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  try {
    const question = yield Api.get(
      `/questions/nextDispute?groupId=${userInfo.licenseData.groupId}&playerId=${userInfo.licenseId}`,
      {}
    )
    yield put(actions.setVoteQuestion(question))
  } catch (e) {
    yield handleError(e, 'no_dispute_question', false)
  }
}

//=============== ANSWER QUESTION ====================//
export function* answerQuestion(action) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const penalized = yield select(quizzesSelector.isAnswerPenalized)
  const question = action.data
  const payload = {
    selectedKey: question.selectedKey,
    groupId: userInfo.licenseData.groupId,
    penalized,
  }

  try {
    const resp = yield Api.post(`/questions/${question.id}/answers`, {}, payload)
    yield put(
      actions.setFeedBack({
        answerId: question.selectedKey,
        correct: resp.right,
        coins: resp.coins,
      })
    )
    yield put(
      pointsManagerActions.setPointsData({ value: '+' + resp.coins, icon: 'icon-coin', style: {} })
    )
    yield put(actions.saveQuestionOk())
    yield put(audioActions.playHowlAudio('click'))
  } catch (e) {
    yield handleError(e, 'no_answer_question', true)
    yield put(miningActions.changeMiningScreen('mining_default'))
    yield put(Game.actions.addPopup('error_answer_popup'))
  }
}

export function* answerQuestionWithWildcard() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const penalized = yield select(quizzesSelector.isAnswerPenalized)
  const payload = { groupId: userInfo.licenseData.groupId, penalized }
  const question = yield select(quizzesSelector.getCurrentQuestion)

  try {
    const resp = yield Api.post(`/questions/${question.id}/wildcard`, {}, payload)
    yield put(actions.setFeedBack({ answerId: 'wildcard', correct: resp.right, coins: resp.coins }))
    yield put(
      pointsManagerActions.setPointsData({ value: '+' + resp.coins, icon: 'icon-coin', style: {} })
    )
  } catch (e) {
    yield handleError(e, 'answer_with_wildcard', true)
    yield put(miningActions.changeMiningScreen('mining_default'))
    yield put(Game.actions.addPopup('error_answer_popup'))
  }
}

export function* refuseQuestion(action) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const question = action.data
  const payload = { ...question, groupId: userInfo.licenseData.groupId, status: 'DISPUTED' }

  try {
    yield Api.put(`/questions/${question.id}`, {}, payload)
    yield put(audioActions.playHowlAudio('wrong_answer'))
  } catch (e) {
    yield handleError(e, 'refuse_question', true)
    yield put(Game.actions.addPopup('error_dispute_popup'))
  }
  yield endFlow()
  yield put(actions.setQuestion(null))
}
//=============== END ANSWER ====================//

//=============== ASK ====================//
export function* sendQuestion(action) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const question = action.data
  const payload = { ...question, groupId: userInfo.licenseData.groupId }
  const prizeCoins = yield select(quizzesSelector.getCreatePrizeCoins)

  try {
    yield Api.post(`/questions`, {}, payload)
    yield put(actions.saveQuestionOk())
    yield put(
      pointsManagerActions.setPointsData({ value: '+' + prizeCoins, icon: 'icon-coin', style: {} })
    )
    yield endFlow()
    yield put(audioActions.playHowlAudio('click'))
  } catch (e) {
    yield handleError(e, 'no_send_question', true)
    yield put(miningActions.changeMiningScreen('mining_default'))
  }
}
//=============== END ASK ====================//

//=============== DEBATE ====================//
export function* voteQuestion(action) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const question = action.data
  const payload = { ...question, groupId: userInfo.licenseData.groupId }

  try {
    yield Api.put(`/questions/${question.id}/${question.vote}`, {}, payload)
    yield put(audioActions.playHowlAudio('click'))
  } catch (e) {
    yield handleError(e, 'invalid_vote_question', true)
    yield put(Game.actions.addPopup('error_debate_popup'))
  }
  yield put(actions.setVoteQuestion(null))
  yield endFlow()
}
//=============== END DEBATE ====================//

export function* likeQuestion(action) {
  const question = action.data

  try {
    yield Api.put(`/questions/${question.id}/${question.like}`, {})
    yield put(
      pointsManagerActions.setPointsData({
        value: '+' + GIVE_LIKE_PRIZE,
        icon: 'icon-antimateria',
        style: { antimatter: true },
      })
    )
    yield put(audioActions.playHowlAudio('click'))
  } catch (e) {
    yield handleError(e, 'no_like_question', true)
  }
}
export function* getDisputesSagas() {
  try {
    const data = yield Api.get(`/questions/disputes/list`, {})
    yield put(actions.getDisputesSuccess(data))
  } catch (e) {
    yield put(actions.getDisputesError('get_disputes_error'))
    yield handleError(e, 'get_disputes_error', false)
  }
}

export function* getAllDisputes() {
  try {
    const data = yield Api.get(`/questions/disputes/list`, {})
    yield put(actions.setDisputesList(data))
  } catch (e) {
    yield put(actions.getDisputesError('get_list_disputes_error'))
    yield handleError(e, 'get_list_disputes_error', false)
  }
}

function* handleError(e, info, sound) {
  yield put(actions.saveQuestionError(info))
  console.log(e)
  if (e && e.status === 401) {
    console.log('Unauthorized')
    yield put(Game.actions.returnToPlatform())
  }
  if (sound) {
    yield put(audioActions.playHowlAudio('wrong_answer'))
  }
}

function* endFlow() {
  const executeEventPercent = Math.floor(Math.random() * 100) + 1
  executeEventPercent <= EVENT_PERCENT
    ? yield put(eventsActions.loadEvent())
    : yield put(miningActions.changeMiningScreen('mining_default'))
}

export function* sagas() {
  yield init()
  yield all([
    takeEvery(actions.CREATE_QUESTION, sendQuestion),
    takeEvery(actions.GET_QUESTIONS_LIST, getQuestionsList),
    takeEvery(actions.ANSWER_QUESTION, answerQuestion),
    takeEvery(actions.GET_DISPUTES_LIST, getDisputesSagas),
    takeEvery(actions.GET_ALL_DISPUTES_LIST, getAllDisputes),
    takeEvery(actions.GET_QUESTION, getQuestion),
    takeEvery(actions.GET_DISPUTE_QUESTION, getDisputeQuestion),
    takeEvery(actions.REFUSE_QUESTION, refuseQuestion),
    takeEvery(actions.VOTE_QUESTION, voteQuestion),
    takeEvery(actions.LIKE_QUESTION, likeQuestion),
    takeEvery(actions.BUY_WILDCARD, buyWildcard),
    takeEvery(actions.USE_WILDCARD, answerQuestionWithWildcard),
    takeEvery(actions.END_FLOW, endFlow),
  ])
}
